import React, {Component} from 'react'
import { Button, Modal } from 'react-bootstrap'
import { connectModal } from 'redux-modal'

import {
  updateTransaction
} from 'broker/redux/account'

class ReferralNote extends Component {

  constructor(props) {
    super(props)

    this.state = {
      note: this.props.item.broker_note,
    }

    this.handleSave = this.handleSave.bind(this)
  }

  handleSave() {
    let state = {...this.state}

    this.props.dispatch(updateTransaction(this.props.item.id, state))
      .then(() => (this.props.onSave()))
      .then(() => this.props.handleHide())
  }

  render() {

    return (
      <Modal show={this.props.show}>
        <Modal.Header>
          <Modal.Title>Note - {this.props.item.name}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="PipelineNote">
            <fieldset className="form-group">
              <label>Note</label>
              <textarea
                className="form-control"
                value={this.state.note}
                onChange={e => this.setState({note: e.target.value})}
              />
            </fieldset>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={this.props.handleHide}>Close</Button>
          <Button onClick={this.handleSave} bsStyle="primary">Save</Button>
        </Modal.Footer>
      </Modal>)
  }
}
const ReferralNoteModal = connectModal({ name: 'ReferralNoteModal', destroyOnHide: true })(ReferralNote)

export default ReferralNoteModal
